import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in Object.keys(value)) {
        keys.push({key: key, value: value[key]});
    }
    console.log(keys);
    return keys;
  }
}